"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavbarSearch = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
require("@/components/common");
require("@/components/domains/search/search-result-list");
const pagefind_search_controller_1 = require("@/components/layouts/navbar-search/pagefind-search-controller");
require("@/components/overlay/sheet");
function hasValue(target) {
    return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;
}
/**
 * navbar 검색 트리거와 검색 시트를 함께 소유하는 컴포넌트.
 * 트리거가 내부에 있어 열기/닫기·query·검색 결과 상태를 모두 스스로 관리한다.
 */
let NavbarSearch = class NavbarSearch extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.search = new pagefind_search_controller_1.PagefindSearchController(this, { isActive: () => this.isOpen });
        this.handleSearchButtonClick = () => {
            this.isOpen = !this.isOpen;
        };
        // 시트가 배경·ESC·닫기 버튼으로 스스로 닫힌 경우도 이 이벤트로 상태를 맞춘다.
        this.handleSheetToggle = (e) => {
            this.isOpen = e.detail.open;
        };
        this.handleSearchInput = (e) => {
            this.search.setQuery(this.getInputValue(e));
        };
    }
    /* eslint-disable lit-a11y/no-autofocus -- 시트가 열릴 때 검색 입력으로 바로 들어가는 것이 이 표면의 목적이다. */
    render() {
        return (0, lit_1.html) `
      <mm-icon-button
        icon=${common_1.ICON_NAMES.SEARCH}
        aria-label="검색"
        aria-expanded=${this.isOpen ? 'true' : 'false'}
        @click=${this.handleSearchButtonClick}
      ></mm-icon-button>

      <mm-sheet
        placement="top"
        style="--backdrop-blur: 2px"
        ?open=${this.isOpen}
        @toggle=${this.handleSheetToggle}
      >
        <mm-sheet-header heading="검색"></mm-sheet-header>
        <mm-sheet-body>
          <form role="search" style="display: flex; flex-direction: column; gap: var(--space-2)">
            <mm-searchfield
              autofocus
              placeholder="컴포넌트, 패턴을 검색하세요"
              .value=${this.search.query}
              @input=${this.handleSearchInput}
            ></mm-searchfield>
            ${this.renderResults()}
          </form>
        </mm-sheet-body>
      </mm-sheet>
    `;
    }
    /* eslint-enable lit-a11y/no-autofocus */
    updated(changed) {
        if (!changed.has('isOpen'))
            return;
        if (this.isOpen)
            this.search.load();
        else
            this.search.reset(true);
    }
    getInputValue(e) {
        const detailValue = e instanceof CustomEvent ? e.detail?.value : undefined;
        return detailValue ?? (hasValue(e.target) ? e.target.value : '');
    }
    renderResults() {
        if (!this.search.query)
            return lit_1.nothing;
        if (this.search.searching) {
            return (0, lit_1.html) `
        <mm-paragraph color="light">검색 중...</mm-paragraph>
      `;
        }
        if (this.search.results.length === 0) {
            return (0, lit_1.html) `
        <mm-paragraph color="light">'${this.search.query}'에 대한 결과가 없습니다.</mm-paragraph>
      `;
        }
        return (0, lit_1.html) `
      <mm-search-result-list
        heading="검색 결과"
        .results=${this.search.results}
      ></mm-search-result-list>
    `;
    }
};
NavbarSearch.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
    }
  `;
__decorate([
    (0, decorators_js_1.state)()
], NavbarSearch.prototype, "isOpen", void 0);
NavbarSearch = __decorate([
    (0, decorators_js_1.customElement)('mm-navbar-search')
], NavbarSearch);
exports.NavbarSearch = NavbarSearch;
//# sourceMappingURL=data:application/json;base64,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